<template>
  <v-app id="inspire" v-resize="onResize">
    <v-navigation-drawer v-model="drawer" :width="isMobile?'100%':'350px'" v-if="logueado" absolute temporary>
      <div v-if="logueado">
        <v-list-item class="px-2">
          <v-list-item-avatar>
            <v-img src="/LogoMegalabs.png"></v-img>
          </v-list-item-avatar>
          <v-list-item-title class="text-center black--text">
            <strong>Sistema de Presupuesto</strong>
          </v-list-item-title>
          <v-btn icon @click.stop="drawer = !drawer">
            <v-icon>keyboard_arrow_left</v-icon>
          </v-btn>
        </v-list-item>
        <v-list-item class="text-center primary--text">
          <strong>{{ $store.state.usuario.nombre }}</strong>
        </v-list-item>
      </div>

      <v-list dense>
        <v-list-item :to="{ name: 'Home' }">
          <v-list-item-icon>
            <v-icon>home</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Inicio</v-list-item-title>
        </v-list-item>

        <v-list-group
          v-for="item in items"
          :key="item.title"
          v-model="item.active"
          :prepend-icon="item.action"
          v-show="permisos.tieneRol(item.rol)"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="child in item.items"
            :key="child.title"
            :to="child.direccion"
            v-show="permisos.tieneRol(child.rol)"
          >
            <v-list-item-title>{{ child.title }}</v-list-item-title>
            <v-list-item-icon>
              <v-icon >{{ child.icon }}</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>

        <v-list-item @click="salir()">
          <v-list-item-icon>
            <v-icon>fa-solid fa-right-from-bracket</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Cerrar Sesión</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-card flat>
      <v-app-bar color="white" dense flat>
        <v-app-bar-nav-icon
          color="secondary"
          @click.stop="drawer = !drawer"
        ></v-app-bar-nav-icon>
        <v-toolbar-title class="font-weight-black secondary--text">{{
          this.$store.state.titulo
        }}</v-toolbar-title>

        <v-spacer></v-spacer>
        <v-menu
        v-model="menu"
        bottom
        right
        transition="scale-transition"
        origin="top left"
        v-if="logueado"
      >
        <template v-slot:activator="{ on }">
          <v-chip
            pill
            v-on="on"
            color="grey lighten-4"
          >
            
            <strong v-if="!isMobile">{{ $store.state.usuario.nombre }}</strong>
            <strong v-else>{{ iniciales($store.state.usuario.nombre) }}</strong>
            
          </v-chip>
        </template>
        <v-card :max-width="isMobile?'400px':'300px'">
          <v-list light>
            <v-list-item>
            
              <v-list-item-content>
                <v-list-item-title class="primary--text" ><strong>{{ $store.state.usuario.nombre }}</strong></v-list-item-title>
                <v-list-item-subtitle>{{ $store.state.usuario.user }}@megalabs.com.bo</v-list-item-subtitle>
              </v-list-item-content>
              
            </v-list-item>
          </v-list>
          <v-list>
            <v-list-item @click="() => {}">
              <v-list-item-action>
                <v-icon color="primary">fa-solid fa-right-from-bracket</v-icon>
              </v-list-item-action>
              
             
              <v-list-item-subtitle @click="salir()" class="primary--text" >Cerrar Sesión</v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
        
      </v-app-bar>
    </v-card>
    <v-main>
      <v-container class="fill-height" fluid>
        <v-slide-y-transition mode="out-in">
          <router-view />
        </v-slide-y-transition>
      </v-container>
    </v-main>

    <v-snackbar
      v-for="(snackbar, index) in snackbars.filter((s) => s.showing)"
      :key="snackbar.text + Math.random()"
      v-model="snackbar.showing"
      :timeout="snackbar.timeout"
      :top="true"
      :color="snackbar.color"
      :right="true"
      :style="`top: ${index * 70}px`"
      
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          color="white"
          small
          fab
          text
          dark
          @click="snackbar.showing = false"
        >
          <v-icon>cancel</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>
<style>
td {
  /* font-family: "Arial", Arial, sans-serif !important; */
  font-size: 14px !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
}

th {
  background-color: #fff;
  color: #000;
  height: 0px !important;
}

table {
  border-collapse: collapse;
  width: 100%;
  height: 0px !important;
}

table,
th,
td {
  height: 0px !important;
  border: 0.2px solid rgb(236, 233, 233);
}

.theme--light.v-data-table thead tr th {
  text-align: center !important;
  /* vertical-align: middle !important; */
}
</style>

<script>
import { mapState } from "vuex";

import axios from "axios";

export default {
  props: {
    source: String,
  },

  data: () => ({
    gestion: "",
    menu: false,
    dialog: false,
    drawer: null,
    appName: "",
    mini: true,
    isMobile: false,
    itemsSnack: [],
    items: [
      {
        action: "analytics",
        active: true,
        rol: "ADM,COM,GDP,ENC,NOM,PRE",
        items: [
          {
            title: "Presupuestos Globales",
            direccion: { name: "Presupuesto" },
            icon: "stacked_line_chart",
            rol: "ADM,ENC",
          },
          {
            title: "Presup. Marketing",
            direccion: { name: "PresupuestoLineaCom" },
            icon: "fa-solid fa-ranking-star",
            rol: "ADM,COM,GDP",
          },
          {
            title: "Seguimiento Marketing",
            direccion: { name: "SeguimientoLineaCom" },
            icon: "fa-solid fa-dollar-sign",
            rol: "ADM,COM,GDP",
          },
          {
            title: "Presup. Nóminas",
            direccion: { name: "PresupuestoLineaNominas" },
            icon: "fa-solid fa-users",
            rol: "ADM,NOM,PRE",
          },
          {
            title: "Planillas de Nóminas",
            direccion: { name: "Planillas" },
            icon: "group",
            rol: "ADM,NOM,PRE",
          },
        ],
        title: "Presupuesto",
      },
      {
        action: "account_balance",
        active: true,
        rol: "ADM,ENC",
        items: [
          {
            title: "Centro de Costo",
            direccion: { name: "Centro_costo" },
            icon: "business_center",
            rol: "ADM,ENC",
          },
          {
            title: "Cuenta Contable",
            direccion: { name: "Cuenta_contable" },
            icon: "account_balance_wallet",
            rol: "ADM,ENC",
          },
        ],
        title: "Contabilidad",
      },
      {
        action: "person",
        active: true,
        rol: "ADM,NOM,JEF,PRE",
        items: [
          {
            title: "Area",
            direccion: { name: "Area" },
            icon: "fa-solid fa-people-group",
            rol: "ADM,NOM",
          },
          {
            title: "Subarea",
            direccion: { name: "Subarea" },
            icon: "6_ft_apart",
            rol: "ADM,NOM",
          },
          {
            title: "Area del Presupuesto",
            direccion: { name: "Area_presupuesto" },
            icon: "reduce_capacity",
            rol: "ADM,NOM",
          },
          {
            title: "Cargo",
            direccion: { name: "Cargo" },
            icon: "hail",
            rol: "ADM,NOM",
          },
          {
            title: "Persona",
            direccion: { name: "Persona" },
            icon: "fa-solid fa-person",
            rol: "ADM,NOM",
          },
          {
            title: "Solicitud de Personal",
            direccion: { name: "SolicitudNuevoPersonal" },
            icon: "fa-solid fa-person-circle-plus",
            rol: "ADM,JEF",
          },
          {
            title: "Cambios de Personal",
            direccion: { name: "Cambios_personal" },
            icon: "fa-solid fa-person-military-to-person",
            rol: "ADM,NOM",
          },
          
          {
            title: "Equipo",
            direccion: { name: "Equipo" },
            icon: "people",
            rol: "ADM,NOM",
          },
          {
            title: "Nit",
            direccion: { name: "Nit" },
            icon: "badge",
            rol: "ADM,NOM",
          },
           {
            title: "Otros gastos de Personal",
            direccion: { name: "SubcategoriaConfig" },
            icon: "fa-solid fa-sliders",
            rol: "ADM,NOM,PRE",
          },
          {
            title: "Uniformes",
            direccion: { name: "Uniforme" },
            icon: "fa-solid fa-tshirt",
            rol: "ADM,PRE",
          }
          
        ],
        title: "Personal",
      },
      {
        action: "precision_manufacturing",
        active: true,
        rol: "ADM,ENC",
        items: [
          {
            title: "Articulo",
            direccion: { name: "Articulo" },
            icon: "inventory_2",
            rol: "ADM,ENC",
          },
          {
            title: "Familia",
            direccion: { name: "Familia" },
            icon: "workspaces",
            rol: "ADM,ENC",
          },
          {
            title: "Linea de Venta",
            direccion: { name: "Linea_venta" },
            icon: "storefront",
            rol: "ADM,ENC",
          },
          {
            title: "Gerente de Producto",
            direccion: { name: "Gdp" },
            icon: "directions_run",
            rol: "ADM,ENC",
          },
          {
            title: "Forma Farmacéutica",
            direccion: { name: "Forma_farmaceutica" },
            icon: "local_pharmacy",
            rol: "ADM,ENC",
          },
        ],
        title: "Producto",
      },
      {
        action: "settings",
        active: true,
        rol: "ADM,NOM,ENC,COM,PRE",
        items: [
          {
            title: "Parámetros Generales",
            direccion: { name: "Parametro" },
            icon: "settings",
            rol: "ADM,ENC",
          },
          {
            title: "Servicio",
            direccion: { name: "Servicio" },
            icon: "support_agent",
            rol: "ADM,ENC",
          },
          {
            title: "Categoría",
            direccion: { name: "Categoria" },
            icon: "fa-solid fa-layer-group",
            rol: "ADM,NOM,PRE",
          },
          {
            title: "Subcategoría",
            direccion: { name: "Subcategoria" },
            icon: "fa-solid fa-object-group",
            rol: "ADM,NOM,PRE",
          },
         
          {
            title: "Tipo de Aprobación",
            direccion: { name: "Tipo_aprobacion" },
            icon: "beenhere",
            rol: "ADM,COM",
          },
          {
            title: "Grupos",
            direccion: { name: "Grupo_nomina" },
            icon: "fa-solid fa-user-group",
            rol: "ADM,NOM,PRE",
          },
          {
            title: "Usuarios",
            direccion: { name: "Usuario" },
            icon: "fa-solid fa-user-cog",
            rol: "ADM,NOM",
          },
        ],
        title: "Parámetros",
      },

      {
        action: "dashboard",
        active: true,
        rol: "ADM,NOM,ENC,REP",
        items: [
          {
            title: "Reporte de Vacación",
            direccion: { name: "Reporte_vacacion" },
            icon: "fa-regular fa-map",
            rol: "ADM,ENC,REP",
          },
          {
            title: "Vacaciones Anuales",
            direccion: { name: "VacacionesAnuales" },
            icon: "fa-solid fa-calendar-day",
            rol: "ADM,ENC,REP",
          },
          {
            title: "A.Importe",
            direccion: { name: "Analisis_importe" },
            icon: "payments",
            rol: "ADM,NOM",
          },
          {
            title: "A.Cantidad",
            direccion: { name: "Analisis_cantidad" },
            icon: "workspaces",
            rol: "ADM,NOM",
          },
          {
            title: "Area Presupuesto",
            direccion: { name: "Analisis_cantidad_AP" },
            icon: "workspaces",
            rol: "ADM,NOM",
          },
          {
            title: "Total Ganado",
            direccion: { name: "Analisis_total_ganado" },
            icon: "workspaces",
            rol: "ADM,NOM",
          },
          {
            title: "Indicadores",
            direccion: { name: "Indicadores" },
            icon: "fa-solid fa-chart-line",
            rol: "ADM,NOM",
          },
          {
            title: "Análisis de Gastos",
            direccion: { name: "Analisis_gastos" },
            icon: "fa-solid fa-money-bill-trend-up",
            rol: "ADM,NOM",
          },
        ],
        title: "Reportes",
      },
    ],
  }),
  computed: {
    ...mapState(["current user", "snackbars"]),

    logueado() {
      var now = new Date();
      try {
        var expira = this.$store.state.usuario.exp;
      } catch {
        var expira = now.getTime();
      }

      
      var nowTimeStamp = now.getTime();      
      var diferencia = nowTimeStamp - expira;      
      var dif = diferencia <= 0 ? false : true;
      

      return dif ? this.$store.state.usuario : false;
    },

    obtenerRol() {
      var rol = "";
      if (this.$store.state.usuario) {
        // Compatibilidad con múltiples roles - devolver el primer rol activo o el rol único
        if (this.$store.state.usuario.roles && Array.isArray(this.$store.state.usuario.roles)) {
          const rolesActivos = this.$store.state.usuario.roles.filter(r => r.activo);
          if (rolesActivos.length > 0) {
            rol = rolesActivos[0].nombre;
          }
        } else if (this.$store.state.usuario.rol) {
          // Compatibilidad con sistema anterior
          rol = this.$store.state.usuario.rol;
        }
      }
      return rol;
    },

    // Computed que calcula todos los permisos de una vez para que sea reactivo
    permisos() {
      const permisos = {};
      
      if (!this.$store.state.usuario) {
        return permisos;
      }
      
      // Obtener roles del usuario
      let rolesUsuario = [];
      if (this.$store.state.usuario.roles && Array.isArray(this.$store.state.usuario.roles)) {
        // Sistema de múltiples roles - solo considerar roles activos
        rolesUsuario = this.$store.state.usuario.roles
          .filter(r => r.activo)
          .map(r => r.codigo || r.nombre);
      } else if (this.$store.state.usuario.rol) {
        // Sistema anterior - rol único
        rolesUsuario = [this.$store.state.usuario.rol];
      }
      
      // Crear función helper para verificar permisos
      permisos.tieneRol = (rolesRequeridos) => {
        if (!rolesRequeridos) return false;
        
        const rolesRequeridosArray = rolesRequeridos.split(',').map(r => r.trim());
        const tieneAcceso = rolesUsuario.some(rolUsuario => rolesRequeridosArray.includes(rolUsuario));
        
        return tieneAcceso;
      };
      
      return permisos;
    },

    // Mantener el método anterior como backup pero sin logs
    tieneRol() {
      return (rolesRequeridos) => {
        if (!this.$store.state.usuario) return false;
        
        // Obtener roles del usuario
        let rolesUsuario = [];
        if (this.$store.state.usuario.roles && Array.isArray(this.$store.state.usuario.roles)) {
          // Sistema de múltiples roles - solo considerar roles activos
          rolesUsuario = this.$store.state.usuario.roles
            .filter(r => r.activo)
            .map(r => r.codigo || r.nombre);
        } else if (this.$store.state.usuario.rol) {
          // Sistema anterior - rol único
          rolesUsuario = [this.$store.state.usuario.rol];
        }
        
        // Convertir string de roles requeridos a array
        const rolesRequeridosArray = rolesRequeridos.split(',').map(r => r.trim());
        
        // Verificar si el usuario tiene al menos uno de los roles requeridos
        return rolesUsuario.some(rolUsuario => rolesRequeridosArray.includes(rolUsuario));
      };
    },
  },
  mounted() {    
    this.onResize();
  },

  watch: {
    // Watcher para detectar cambios en los roles del usuario
    '$store.state.usuario.roles': {
      handler(newRoles, oldRoles) {
        // Forzar re-render del componente para actualizar permisos del menú
        this.$forceUpdate();
      },
      deep: true
    },
    
    // Watcher para detectar cambios en el usuario completo
    '$store.state.usuario': {
      handler(newUser, oldUser) {
        if (newUser !== oldUser) {
          this.$forceUpdate();
        }
      },
      deep: true
    }
  },

  created() {
    //this.$gtag.pageview('/areaDelPresupuestoPrueba')
    this.$store.dispatch("autoLogin");
  },
  updated() {},
  methods: {
    salir() {
      this.$store.dispatch("salir");
    },
    
    onResize() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.isMobile = this.width < 768;
    },
    iniciales(cadena) {
      var inicial = "";
      var separador = " ";
      var arregloDeSubCadenas = cadena.split(separador);
      var subCadena = "";

      for (var x = 0; x < arregloDeSubCadenas.length; x++) {
        subCadena = arregloDeSubCadenas[x].substring(0, 1);
        inicial = inicial + subCadena + "";
      }
      return inicial;
    },
  },
};
</script>
